import { render } from "./HeroSet3.vue?vue&type=template&id=f4cb3e4c&scoped=true"
import script from "./HeroSet3.vue?vue&type=script&lang=js"
export * from "./HeroSet3.vue?vue&type=script&lang=js"

import "./HeroSet3.vue?vue&type=style&index=0&id=f4cb3e4c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-f4cb3e4c"

export default script